
//export const API_BASE_URL = "http://localhost:9091";
export const API_BASE_URL = location.protocol + "//" + location.host;
//bizbook vTraders server
//export const API_BASE_URL = "https://abagencies.p4bizbooks.com";

const ENV = process.env.NODE_ENV || 'local';

export const ACCESS_TOKEN = "accessToken";
export const crole = "";

export const POLL_LIST_SIZE = 30;
export const MAX_CHOICES = 6;
export const POLL_QUESTION_MAX_LENGTH = 140;
export const POLL_CHOICE_MAX_LENGTH = 40;

export const NAME_MIN_LENGTH = 4;
export const NAME_MAX_LENGTH = 40;

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 15;

export const EMAIL_MAX_LENGTH = 40;

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 20;

export const colordboarder = {
  borderColor: "red",
};
export const defaultboarder = {
  borderColor: "#e4e6eb",
};

export const containerStyle = {
  top: 55,
};

export const loadertype = "line-scale";
export const loaderMsg = "Loading, Please Wait";

export const defaultRegex = /[0-9~!{}\[\]\@#$%^_=*?.,\\;:]/g;
export const defaultRegexW = /[0-9~! {}\[\]\@#$%^_=*?.,\\;:]/g;

export const onlyChrRegex = /[^u-u0-9]/g;

export const spregex = /^[^a-zA-Z0-9]+$/;

export const brandColor = "#46beed";

export const defaultStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? 0 : 0,
    borderColor: "#E4E6EB",
    "&:hover": {
      borderColor: "#E4E6EB",
    },
  }),
};

export const reddefaultStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? 0 : 0,
    borderColor: "red",
    "&:hover": {
      borderColor: "red",
    },
  }),
};



// WEBPACK FOOTER //
// ./src/constants/index.js